import { useAsyncExecutor } from "async-executor-hook";
import { Toast } from "primereact/toast";
import { useEffect, useRef } from "react";
import {
  FormControl,
  FormGroup,
  useFormConfig,
  WForm,
  WFormControl,
} from "rectangular-forms";
import { BodyContainerTableCommon } from "../../../common/components/TableResponsive";
import {
  onlyLetter,
  WDropdown,
  WInputText,
} from "../../../common/components/TemplateContainer/InputTemplates";
import { SaveButton } from "../../../common/components/TemplateContainer/SaveButton";
import { TemplateInputContainer } from "../../../common/components/TemplateContainer/TemplateContainer";
import { getErrorValueResponse } from "../../../common/error/Error";
import { removeNullProps } from "../../../common/utils";
import { HTTP_METHODS } from "../../../utils/constants";
import { networkBackendRequest } from "../../../utils/networkUtils";
import { REDUCE_DAYS } from "../../../utils/valueStaticConstants";
import { ContainerInputs, ContainerTitleSync } from "../SyncronizeDataStyled";

interface IcreateUserExecutorParams {
  category_option: string[];
  partial_name: string;
  last_ndays: number;
  succeed?: any;
  failed?: any;
}

export const SyncronizeUsersByName = () => {
  const toast: any = useRef();
  const formConfig = useFormConfig({
    createForm: (data) => {
      const form = new FormGroup({
        category_option: new FormControl(),
        partial_name: new FormControl(),
      });
      form.patchValue(data);
      return form;
    },
    onSubmit: (form, { processing, succeed, failed }) => {
      if (form.invalid) {
        toast.current.show({
          severity: "error",
          summary:
            "Completar todos los campos obligatorios antes de continuar. ¡Gracias!",
          contentClassName: "",
        });
        return;
      }
      const category_option = [form.value.category_option];
      processing();
      createUserExecutor.execute({
        ...form.value,
        succeed,
        failed,
        last_ndays: REDUCE_DAYS,
        category_option,
      });
    },
  });

  const createUserExecutor = useAsyncExecutor(
    (params: IcreateUserExecutorParams) => {
      const { partial_name, category_option } = params;
      const urlPostUserByName =
        "/sync-engine/manual-synchronization/users/by-name/";
      return networkBackendRequest(
        urlPostUserByName,
        HTTP_METHODS.POST,
        removeNullProps({ name: partial_name, category: category_option })
      ).then((resp) => resp.json());
    },
    {
      onSuccess: (_, params: IcreateUserExecutorParams) => {
        params.succeed();
        formConfig.loadSucceed({ category_option: "DRIVER" });
        toast.current.show({
          severity: "success",
          summary: "Operación exitosa",
          detail: `La sincronización de ${params.partial_name} se realizó con éxito.`,
          life: 5000,
        });
      },
      onError(error, params: IcreateUserExecutorParams) {
        const errorMessage = getErrorValueResponse(error);
        params.failed();
        toast.current.show({
          severity: "error",
          summary: "Atención",
          detail: errorMessage,
          life: 3000,
        });
      },
    }
  );
  useEffect(() => {
    formConfig.loadSucceed({ category_option: "DRIVER" });
    // eslint-disable-next-line
  }, []);

  const isDisabledButton = formConfig?.form?.value.partial_name < 1;
  return (
    <div>
      <Toast ref={toast}></Toast>
      <WForm formConfig={formConfig} style={{ width: "100%" }}>
        <BodyContainerTableCommon className="item-container" height="10rem">
          <div
            className="attribute"
            style={{
              display: "flex",
              alignItems: "flex-start",
              height: "100%",
            }}
          >
            <div className="titles">{"Sincronizar"}</div>
            <ContainerTitleSync>
              <div style={{ fontSize: "1.6rem", color: "#2E353D" }}>
                En base al nombre
              </div>
              <div style={{ fontSize: "1.2rem", color: "#989CA2" }}>
                <p style={{ maxWidth: "27rem" }}>
                  Sincronice la información de los usuarios en base a su{" "}
                  <strong>categoría</strong> y{" "}
                  <strong>nombres o apellidos.</strong>
                </p>
              </div>
            </ContainerTitleSync>
          </div>
          <div className="attribute" style={{ height: "100%" }}>
            <div className="titles">{"PARÁMETROS DE SINCRONIZACIÓN"}</div>
            <div className="left-align" style={{ width: "100%" }}>
              <ContainerInputs>
                <WFormControl name="category_option">
                  <TemplateInputContainer label="Categoría" color="#002E6C">
                    <WDropdown
                      options={[
                        { label: "Conductor", value: "DRIVER" },
                        {
                          label: "Despachador Aduanero",
                          value: "CUSTOMS_DISPATCHER",
                        },
                      ]}
                      width="20rem"
                      placeholder="Tipo de Categoría"
                    />
                  </TemplateInputContainer>
                </WFormControl>
                <div>
                  <WFormControl name="partial_name">
                    <TemplateInputContainer
                      label="Nombre Parcial"
                      color="#002E6C"
                    >
                      <WInputText
                        width="100%"
                        height="4rem"
                        fontSize="1.4rem"
                        placeholder="Nombre Parcial"
                        onKeyPress={onlyLetter}
                      />
                    </TemplateInputContainer>
                  </WFormControl>
                </div>
              </ContainerInputs>
            </div>
          </div>
          <div className="attribute" style={{ height: "100%" }}>
            <div className="titles">{"ACCIONES"}</div>
            <div className="left-align">
              <SaveButton
                label="Sincronizar"
                width="17rem"
                height="3.8rem"
                fontSize="1.5rem"
                backgroundColor="#002E6C"
                isDisabled={isDisabledButton}
              />
            </div>
          </div>
        </BodyContainerTableCommon>
      </WForm>
    </div>
  );
};
